import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-touches-list',
  templateUrl: './touches-list.component.html',
  styleUrls: ['./touches-list.component.scss']
})
export class TouchesListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.touch;
  }

  @Output() editTouchEmmitter = new EventEmitter();
  @Output() deleteTouchEmmitter = new EventEmitter();

  @Input() touch;

  editTouch(touch: any){
    this.editTouchEmmitter.emit(touch);
  }
  deleteTouch(touch: any){
    this.deleteTouchEmmitter.emit(touch);
  }

}
